import * as tslib_1 from "tslib";
import styled, { withProps } from '../styles';
var Separator = withProps()(styled.div)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: 32px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-size: ", "rem;\n  background-color: ", ";\n  padding-left: 16px;\n"], ["\n  height: 32px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-size: ", "rem;\n  background-color: ",
    ";\n  padding-left: 16px;\n"])), function (props) { return props.theme.typography.body2.fontSize; }, function (props) {
    return props.bgColor || props.theme.palette.background.appBar;
});
export default Separator;
var templateObject_1;
//# sourceMappingURL=Separator.js.map